import { Link } from "@tanstack/react-router";
import type { Expert } from "@/lib/experts";
import { categoryLabel } from "@/lib/experts";

export function ExpertCard({ expert }: { expert: Expert }) {
  return (
    <Link
      to="/experts/$slug"
      params={{ slug: expert.slug }}
      style={{
        display: "block",
        textDecoration: "none",
        background: "var(--ivory)",
        border: "0.5px solid var(--stone-mid)",
        borderRadius: 8,
        padding: 20,
        transition: "box-shadow 160ms ease, transform 160ms ease",
        color: "var(--charcoal)",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = "8px 8px 0 var(--gold-tint)";
        e.currentTarget.style.transform = "translate(-2px,-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "none";
        e.currentTarget.style.transform = "translate(0,0)";
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
        <div
          aria-hidden
          style={{
            width: 40,
            height: 40,
            borderRadius: 6,
            background: "var(--gold-tint)",
            display: "grid",
            placeItems: "center",
            fontFamily: '"Fraunces", serif',
            fontWeight: 900,
            color: "var(--leather)",
            fontSize: 20,
          }}
        >
          {expert.icon ?? expert.name.charAt(0)}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontFamily: '"Fraunces", serif',
              fontWeight: 600,
              fontSize: 18,
              color: "var(--charcoal-deep)",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {expert.name}
          </div>
          <span
            style={{
              display: "inline-block",
              marginTop: 4,
              padding: "2px 8px",
              fontFamily: '"DM Mono", monospace',
              fontSize: 10,
              letterSpacing: 2,
              textTransform: "uppercase",
              color: "var(--leather)",
              background: "var(--cream)",
              border: "0.5px solid var(--leather)",
              borderRadius: 4,
            }}
          >
            {categoryLabel(expert.category)}
          </span>
        </div>
      </div>

      <p
        style={{
          fontFamily: '"DM Sans", sans-serif',
          fontSize: 14,
          lineHeight: 1.5,
          color: "var(--graphite)",
          margin: "0 0 16px",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {expert.short_description}
      </p>

      <div
        style={{
          fontFamily: '"DM Mono", monospace',
          fontSize: 11,
          letterSpacing: 1,
          color: "var(--smoke)",
          borderTop: "0.5px solid var(--stone)",
          paddingTop: 10,
        }}
      >
        {expert.years_expertise ?? "—"} ans d&apos;expertise ·{" "}
        {expert.documents_count ?? 0} documents
      </div>
    </Link>
  );
}

export default ExpertCard;
